import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import RegistrationModal from "./modals/registreModal";
import ForgotPasswordModal from "./modals/forgotPassModal";
import LoginFormModal from "./modals/loginModal";
import dashboardImage from '../assets/images/dashboard.png';
import posBillingImage from '../assets/images/billing.png';
import transactionsImage from '../assets/images/transactions.png';
import reportsImage from '../assets/images/reports.png';
import invoice from '../assets/images/invoice.png'
import products from '../assets/images/products.png'
import ImageSlider from "./imageSlider";

const HeroSection = ({ openModal }) => {
    const [isLoginModalOpen, setLoginModalOpen] = useState(false);
    const [isRegisterModalOpen, setRegisterModalOpen] = useState(false);
    const [isForgotPasswordModalOpen, setForgotPasswordModalOpen] = useState(false);

    const toggleLoginModal = () => {
        setLoginModalOpen(!isLoginModalOpen);
    };

    const toggleRegisterModal = () => {
        setRegisterModalOpen(!isRegisterModalOpen);
    };

    const images = [
        dashboardImage, products, posBillingImage, transactionsImage, reportsImage, invoice
    ];

    useEffect(() => {
        if (isLoginModalOpen || isRegisterModalOpen || isForgotPasswordModalOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }

        return () => {
            document.body.style.overflow = "auto";
        };
    }, [isLoginModalOpen, isRegisterModalOpen, isForgotPasswordModalOpen]);

    return (
        <section id="hero" className="bg-lightGray py-12 min-h-screen">
            <div
                className="container mx-auto flex flex-col lg:flex-row items-center gap-6 px-4 mt-10"
                data-aos="fade-up"
                data-aos-duration="1500"
            >
                {/* Text Section */}
                <div
                    className="lg:w-1/2 text-center lg:text-left"
                    data-aos="fade-right"
                    data-aos-delay="200"
                >
                    <h1
                        className="text-3xl sm:text-4xl font-bold text-primary"
                        data-aos="zoom-in"
                        data-aos-delay="300"
                    >
                        Welcome to INVETIX POS
                    </h1>
                    <p
                        className="text-gray-700 mt-4"
                        data-aos="fade-up"
                        data-aos-delay="500"
                    >
                        Simplify your store operations with our intuitive POS and billing system. Gain actionable insights, process transactions efficiently, and analyze reports with ease.
                    </p>
                    <div
                        className="mt-6 space-x-4"
                        data-aos="fade-up"
                        data-aos-delay="700"
                    >
                        <div className="flex justify-center space-x-4">
                            <button
                                onClick={toggleRegisterModal}
                                className="bg-primary text-white px-8 py-3 rounded-lg shadow-lg hover:bg-primary-hover transition duration-200 text-lg font-medium"
                            >
                                Start Free Trial
                            </button>
                            <button
                                onClick={toggleLoginModal}
                                className="bg-secondary text-white px-8 py-3 rounded-lg shadow-lg hover:bg-secondary-hover transition duration-200 text-lg font-medium"
                            >
                                Log In
                            </button>
                        </div>
                    </div>
                </div>


                <div
                    className="lg:w-2/3 w-full"
                    data-aos="fade-left"
                    data-aos-delay="400"
                    data-aos-duration="1200"
                >
                    <ImageSlider images={images} />
                </div>
            </div>
            <div
                className="container mx-auto flex flex-col items-center gap-6 px-4 mt-10"
                data-aos="fade-left"
                data-aos-delay="200"
            >
                <h2 className="text-3xl font-bold text-primary text-start w-full mt-4">
                    What is INVETIX POS?
                </h2>
                <p className="text-gray-700 mt-2 text-start w-full">
                    INVETIX POS is a comprehensive point-of-sale solution designed to
                    simplify your retail, restaurant, or service-based business operations. With
                    intuitive sales tracking, INVETIX POS empowers businesses to streamline operations,
                    improve efficiency, and enhance customer experience—all from a single platform.
                </p>
            </div>
            {/* Modals */}
            <RegistrationModal isOpen={isRegisterModalOpen} onClose={() => setRegisterModalOpen(!isRegisterModalOpen)} toggleModal={toggleRegisterModal} />
            {isLoginModalOpen && <LoginFormModal toggleModal={toggleLoginModal} openForgotPasswordModal={() => setForgotPasswordModalOpen(true)} />}
            {isForgotPasswordModalOpen && (
                <ForgotPasswordModal
                    toggleModal={() => setForgotPasswordModalOpen(false)}
                />
            )}
        </section>
    );
};

export default HeroSection;